var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('i',{staticClass:"fas fa-spinner fa-spin loader__spinner"}),_vm._t("default",[_vm._v("Loading...")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }